import { CheckedAddress, NormalizedNumber } from '@sparkdotfi/common-universal'
import { isAddress } from 'viem'
import { z } from 'zod'

import { AllocationsSummary } from './logic/getAllocationsSummary'

export const CheckEligibilityFormSchema = z
  .object({
    address: z.string(),
  })
  .superRefine((data, ctx) => {
    if (!isAddress(data.address, { strict: false })) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invalid address',
        path: ['address'],
      })
    }
  })
  .transform((data) => ({ address: CheckedAddress(data.address.toLowerCase()) }))

export type CheckEligibilityFormSchema = z.infer<typeof CheckEligibilityFormSchema>

export type AccountAirdropSummary = {
  totalUnclaimed: NormalizedNumber
  totalClaimed: NormalizedNumber
} & NonNullable<AllocationsSummary>
